import { useNavigate } from 'react-router-dom'
import { ButtonGroup } from '@mui/material'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'
import SidebarAction from '/components/sidebar-action'

const Menu = () => {

  const navigate = useNavigate()

  const page = location.pathname.split("/").pop()

  return (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <ButtonGroup variant="text" aria-label="Actions">
        <SidebarAction label="History" icon={<HistoryOutlinedIcon />} active={page === "history"} onClick={() => navigate("../history")} />
        <SidebarAction label="New Support Request" icon={<AddCommentOutlinedIcon />} active={page === "new"} onClick={() => navigate("../new")} />
      </ButtonGroup>
    </div>

  )
}

export default Menu
